import * as React from 'react';
import { Layout } from '../Layout';
import * as styles from './styles.css';

interface IDocumentsProps {
  header: React.ReactNode;
  list: React.ReactNode;
  toggler: React.ReactNode;
}

export function Documents({ header, list, toggler }: IDocumentsProps) {
  return (
    <Layout>
      <div data-nav-tab="documents/Документы" id="documents" className={styles['nav_container']}>
        <div className={styles['container']}>
          <div className={styles['header']}>{header}</div>
          <div className={styles['list']}>{list}</div>
          {toggler && <div className={styles['toggler']}>{toggler}</div>}
        </div>
      </div>
    </Layout>
  );
}
